import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { setAffiliateRef } from '@/utils/affiliateRef'
import { affiliatesApi, isAffiliateNotFound } from 'api/affiliatesApi'

/**
 * Stores `?ref={slug}` from any page as the partner referral, once the BE
 * confirms it belongs to an approved partner. Unknown slugs (404) are ignored;
 * other lookup failures store it anyway, since sign-up re-validates the slug.
 */
export const useAffiliateRefCapture = (isEnabled: boolean) => {
  const router = useRouter()
  const { ref } = router.query

  useEffect(() => {
    if (!isEnabled || typeof ref !== 'string' || !ref.trim()) return undefined
    const slug = ref.trim()
    // A newer ?ref= cancels this lookup, so a slow response can't overwrite it.
    let isCancelled = false

    affiliatesApi
      .lookupRef(slug)
      .then(() => {
        if (!isCancelled) setAffiliateRef(slug)
      })
      .catch((error) => {
        if (!isCancelled && !isAffiliateNotFound(error)) setAffiliateRef(slug)
      })

    return () => {
      isCancelled = true
    }
  }, [isEnabled, ref])
}
